import React, { Component } from "react";
import { Input, Label } from "arv-reactcomponents";
import PropTypes from "prop-types";
import { PAYMENTPAGE } from "npmlinks-constants";
import ExpYear from "../ExpYear";

class CreditCardHolderName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHolderName: null,
      cardHolderNameError: null,
      isValid: false,
    };
    this.handleCardHolderNameChange = this.handleCardHolderNameChange.bind(
      this,
    );
    this.handleCardHolderNameBlur = this.handleCardHolderNameBlur.bind(this);
  }

  handleCardHolderNameBlur(event) {
    event.preventDefault();
    const validateCardHolderNameField = this.cardHolderNameRef.getValidatedOutput(
      event.target.value,
    );
    const { isValid, value, errorMsg } = validateCardHolderNameField;
    if (!isValid) {
      this.setState({
        cardHolderName: "",
        cardHolderNameError: errorMsg,

        isValid,
      });
    }
    this.props.handleSubmit({ isValid, cardName: value });
  }

  /**
   * This function check the validation based on input and set different error message
   * we can check based on event.target.value also instead of HTML5 constarint validation validity
   * we can access element with Id (native) or with ref also(react)
   * @param event
   */
  handleCardHolderNameChange(event) {
    event.preventDefault();
    const validateCardHolderNameField = this.cardHolderNameRef.getValidatedOutput(
      event.target.value,
    );
    const { isValid, value, errorMsg } = validateCardHolderNameField;
    if (!isValid) {
      this.setState({
        cardHolderName: "",
        cardHolderNameError: errorMsg,
        isValid,
      });
    } else {
      this.setState({
        cardHolderName: value,
        cardHolderNameError: null,
        isValid,
      });
    }
    this.props.handleSubmit({ isValid, cardName: value });
  }

  render() {
    const { cardHolderNameError } = this.state;
    return (
      <div className="nw-creditcardholdername">
        <Label
          htmlFor="nw-paymentoption-cardholdername"
          className="nw-paymentoption-holdername"
        >
          {PAYMENTPAGE.CARDTEXT.CARDHOLDERTITLE}
        </Label>
        <Input
          className="nw-creditcardholdername-input nw-creditcard-input"
          id="nw-paymentoption-cardholdername"
          name="cardholderName"
          value={this.state.cardHolderName}
          ref={values => {
            this.cardHolderNameRef = values;
          }}
          validateWithPattern={[
            {
              pattern: /^[A-Za-z ,.'-]+$/,
              msg: PAYMENTPAGE.CARD_VALIDATION_MESSAGES.CARDHOLDERNAME_PATTERN,
            },
          ]}
          required
          onChange={this.handleCardHolderNameChange}
          onBlur={this.handleCardHolderNameBlur}
        />
        <div className="nw-paymentwallet-error" id="cardholdernameerror">
          {cardHolderNameError}
        </div>
      </div>
    );
  }
}

CreditCardHolderName.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: CreditCardHolderName,
  component: CreditCardHolderName,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/CreditCard/CreditCardHolderName/index.js